import React from 'react'
import {connect} from 'react-redux'
import {Button, ButtonArea} from 'react-weui'
import {browserHistory} from 'react-router'
import Config from '../../config'
import '../../styles/liveroom/LiveroomLectureBtn.css'

class LiveroomLectureBtn extends React.Component {

    constructor() {
        super();
        this.handleAddChannel = this.handleAddChannel.bind(this);
        this.handleAddLecture = this.handleAddLecture.bind(this);
    }

    handleAddLecture() {
        const {liveroom_id} = this.props;
        location.assign(`/liveroom/${liveroom_id}/lecture/create`)
        // window.location.href = Config.MAIN_URL + "/lecture/add?liveroom_id=" + liveroom_id
    }

    handleAddChannel() {
        const {liveroom_id} = this.props;
        location.assign(`/liveroom/${liveroom_id}/channel/create`)
        // window.location.href = Config.MAIN_URL + "/liveroom/add_channel?liveroom_id=" + liveroom_id
    }

    render() {
        return (
            <ButtonArea direction="horizontal" className="LiveroomLectureBtu-container">
                <Button plain className="button btu-re-size button-first default-hover" onClick={this.handleAddLecture}>
                    添加新课程
                </Button>
                <Button className="button  btu-re-size default-hover" onClick={this.handleAddChannel}>
                    创建新专栏
                </Button>
            </ButtonArea>
        )
    }
}

export default connect(state => ({
    liveroom_id: state.liveroom.liveroom.id,
}))(LiveroomLectureBtn)



// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomLectureBtn.js